import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function categoryToSlug(name: string): string {
  return name.toLowerCase().trim().replace(/\s+/g, '-');
}

/**
 * Returns the current date in YYYY-MM-DD format for Europe/Rome timezone.
 * This avoids UTC conversion issues where Italian midnight becomes previous day in UTC.
 */
export function getRomeISODate(date = new Date()): string {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Rome',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);
}
